import BonusSaleReportPage from '../../../shared/reportBonusSale/BonusSaleReportPage'
import {ReportBonusSaleConfig} from '../../../shared/reportBonusSale/ReportBonusSaleConfig'

const config: ReportBonusSaleConfig = {
  reportsBaseUrl: '/api/reports',
  apiEndpoint: 'bonus-sales',
  exportEndpoint: 'bonus-sales/export',
  exportFileName: 'Relatorio_vendas_bonus.xlsx',
  pageTitle: 'Relatório de Vendas Bonus',
  breadcrumbPath: '/reports/reportBonusSale/list',
  navigationPath: '/reports/reportBonusSaleDetail/list',
  navigationPermission: 'reports.bonus_sale_items',
  navigationLabel: 'Detalhado',
  navigationIcon: 'sort',
  isKpi: false,
  showFranchiseFilter: false,
  showClientAlertIcons: true,
  showPaymentsChart: true,
  useSwalErrorHandling: false,
  authPermission: 'reports.bonus_sales',
  exportPermission: 'reports.export',
  dateField: 'createdAt',
  reportType: 'summary',
}

const ReportBonusSalePage = () => <BonusSaleReportPage config={config} />

export default ReportBonusSalePage
